import { Component, OnInit } from '@angular/core';
import { DynamicFormConfigService } from '../dynamic-form-config.service';

@Component({
  selector: 'c-dynamic-form-config-header',
  templateUrl: './dynamic-form-config-header.component.html',
  styleUrls: ['./dynamic-form-config-header.component.scss']
})
export class DynamicFormConfigHeaderComponent implements OnInit {

  constructor(
    public dynamicFormConfigService: DynamicFormConfigService
  ) { }

  ngOnInit() {
  }

}
